import React, { useEffect } from 'react';

import { Box } from '@material-ui/core';

import { PageLoading } from '@vyce/core/src/components/PageLoading';

import { FormToAnswer } from './components/FormToAnswer';
import { CenteredFormMessage } from './components/CenteredFormMessage';
import { AnswerType, FormAnswer, User } from '@vyce/core/src/types';
import { useFormRouteSegment } from './hooks/useFormRouteSegment';
import { useParticipantForm } from './hooks/useParticipantForm';

export const Form: React.FC<{ user: User; companyId: string }> = ({ user, companyId }) => {
  const { id: formId } = useFormRouteSegment('id');
  const { form, loading, getForm, submitFormResponse } = useParticipantForm({ user, companyId });

  const submitForm = async (data: Record<string, string>) => {
    const answers: FormAnswer[] = Object.entries(data).map(([questionId, value]) => ({
      questionId,
      questionIndex: form?.questions.findIndex(question => question.id === questionId) ?? 0,
      value,
      type: form?.questions.find(question => question.id === questionId)?.answer.type as AnswerType,
    }));
    await submitFormResponse(answers);
  };

  useEffect(() => {
    if (formId) {
      getForm(formId);
    }
  }, [formId]);

  if (loading) {
    return <PageLoading />;
  }

  if (!form) {
    return <CenteredFormMessage>Form not found</CenteredFormMessage>;
  }

  return (
    <Box display="flex" justifyContent="center">
      <Box maxWidth={750} width="100%">
        <FormToAnswer form={form} onSave={submitForm} loading={loading} user={user} />
      </Box>
    </Box>
  );
};
